import BtnOptions from './BtnOptions';
import UserSelectStates from '../../../../components/form/Selects/UserSelectStates';

const Report33Options = (props) => {
  const { handleOnSetFieldValue, handleOnSubmit, handleOnSave, values } = props;

  return (
    <>
      <div className="row">
        <div className="col-sm-12">
          <UserSelectStates
            onHandleChange={(opt) => {
              handleOnSetFieldValue('states', opt);
            }}
            value={values?.states}
            getPermissionsFrom="client"
            hasSelectOptions
            hideNotApplicable
            hideObsolete
          />
        </div>
      </div>
      <div className="row">
        <div className="col-12">
          <BtnOptions
            isDisabled={
              !values?.states ||
              values?.states?.length === 0 ||
              (!values?.plantGroups &&
                !values?.plantGroups?.length === 0 &&
                !values?.plants &&
                !values?.plants?.length === 0)
            }
            handleOnSave={() => handleOnSave(true)}
            handleOnSubmit={() => handleOnSubmit()}
          />
        </div>
      </div>
    </>
  );
};

export default Report33Options;
